<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <!-- Title -->
        <span class="ui grey">Home / AOL</span>
        <h2 class="ui primary header">AOL</h2>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <div *ngIf="year" style="display: flex; align-items: center">
        Year : {{ year?.year }}
      </div>
      <sui-select
        class="selection"
        [options]="years"
        [isSearchable]="true"
        labelField="year"
        [(ngModel)]="year"
        placeholder=""
        (ngModelChange)="selectedCurr()"
        #select
      >
        <sui-select-option
          *ngFor="let option of select.filteredOptions"
          [value]="option"
        >
        </sui-select-option>
      </sui-select>
      <button
        class="ui small button primary"
        [disabled]="disabled"
        (click)="submit()"
      >
        Submit
      </button>
    </div>
  </div>
  <div class="ui divider"></div>
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
  </div>
  <p class="warning-label" *ngIf="!disabled">
    Note: Your assessment is yet to be submitted. You will not be able to update
    your assessment after it’s been submitted.
  </p>
  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      style="margin-bottom: 30px"
    >
      <div
        fxLayoutAlign="start center"
        fxLayout="row"
        fxLayoutGap="20px"
        class="link"
      >
        <div class="equipment-id">
          <h2
            class="ui primary header"
            style="
              font-family: 'Roboto';
              font-style: normal;
              font-weight: 500;
              font-size: 14px;
              line-height: 24px;
              color: #000000;
            "
          >
            Network Operator’s Assessment
          </h2>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <button
          class="ui small button primary"
          [disabled]="disabled"
          (click)="addAssessment()"
        >
          Add New
        </button>
      </div>
    </div>
    <app-network-operator-row
      [application]="s"
      [disabled]="disabled"
      [organizationAol]="organizationAol"
      *ngFor="let s of networkAssessments"
      (onView)="viewDepartment($event)"
      (deleteAssessment)="deleteAss($event)"
      (edit)="edit($event)"
    ></app-network-operator-row>
    <app-no-record-found
      *ngIf="networkAssessments && networkAssessments.length < 1"
    ></app-no-record-found>
    <div
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
      style="margin-bottom: 0px; margin-top: 20px"
    >
      <div fxFlex="15%" style="align-self: center" class="table-data"></div>

      <div fxFlex="15%" style="align-self: center" class="table-data"></div>

      <div fxFlex="10%" style="align-self: center" class="table-data"></div>
      <div fxFlex="15%" style="align-self: center" class="table-data"></div>
      <div fxFlex="15%" style="align-self: center" class="table-data"></div>
      <div fxFlex="10%" style="align-self: center" class="table-data">
        <p
          style="
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 140%;
            color: #505050;
          "
        >
          {{ totalpercentPayable | amount }}
        </p>
      </div>
      <div fxFlex="10%" style="align-self: center" class="table-data"></div>
      <div fxFlex="10%" style="align-self: center" class="table-data"></div>
    </div>
  </div>

  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      style="margin-bottom: 30px"
    >
      <div
        fxLayoutAlign="start center"
        fxLayout="row"
        fxLayoutGap="20px"
        class="link"
      >
        <div class="equipment-id">
          <h2
            class="ui primary header"
            style="
              font-family: 'Roboto';
              font-style: normal;
              font-weight: 500;
              font-size: 14px;
              line-height: 24px;
              color: #000000;
            "
          >
            Non-Network Operator’s Assessment
          </h2>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <button
          class="ui small button primary"
          [disabled]="disabled"
          (click)="addNonAssessment()"
        >
          Add New
        </button>
      </div>
    </div>
    <app-non-network-operator-row
      [application]="s"
      [disabled]="disabled"
      [organizationAol]="organizationAol"
      *ngFor="let s of nonNetworkAssessments"
      (onView)="viewNonDepartment($event)"
      (deleteAssessment)="deleteNonAss($event)"
      (edit)="editNonAss($event)"
    ></app-non-network-operator-row>
    <app-no-record-found
      *ngIf="nonNetworkAssessments && nonNetworkAssessments.length < 1"
    ></app-no-record-found>
    <div
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
      style="margin-bottom: 0px; margin-top: 20px"
    >
      <div fxFlex="15%" style="align-self: center" class="table-data"></div>
      <div fxFlex="15%" style="align-self: center" class="table-data">
        <p
          style="
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 140%;
            color: #505050;
          "
        >
          {{ NonTotalpercentPayable | amount }}
        </p>
      </div>
      <div fxFlex="25%" style="align-self: center" class="table-data"></div>
      <div fxFlex="15%" style="align-self: center" class="table-data"></div>
      <div fxFlex="15%" style="align-self: center" class="table-data"></div>
      <!-- <div fxFlex="15%" style="align-self: center" class="table-data"></div> -->
    </div>
  </div>
  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      style="margin-bottom: 30px"
    >
      <div
        fxLayoutAlign="start center"
        fxLayout="row"
        fxLayoutGap="20px"
        class="link"
      >
        <div class="equipment-id">
          <h2
            class="ui primary header"
            style="
              font-family: 'Roboto';
              font-style: normal;
              font-weight: 500;
              font-size: 14px;
              line-height: 24px;
              color: #000000;
            "
          >
            Document Upload
          </h2>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <button class="ui small button primary" (click)="upload()">
          Add New
        </button>
      </div>
    </div>
    <app-document-upload-row
      [application]="s"
      [organizationAol]="organizationAol"
      [disabled]="disabled"
      *ngFor="let s of documents"
      (onView)="viewDocument($event)"
      (deleteAssessment)="deleteDocument($event)"
      (edit)="editDocument($event)"
    ></app-document-upload-row>
    <app-no-record-found
      *ngIf="documents && documents.length < 1"
    ></app-no-record-found>
  </div>
</div>
